function _prepOptions(keyOrOptions, valueOrNull?) { // allows key to be a key or more detailed object
	if (typeof keyOrOptions === 'string') {
		return { key: keyOrOptions, value: valueOrNull };
	}
	return keyOrOptions;
}

const clientStorage = {

	getItem(keyOrOptions) {
		const options = _prepOptions(keyOrOptions);
		const serialized = localStorage.getItem(options.key);

		if (serialized === null || typeof serialized === 'undefined') {
			return Promise.resolve();
		}
		return Promise.resolve(JSON.parse(serialized));
	},

	setItem(keyOrOptions, valueOrNull) {
		const options = _prepOptions(keyOrOptions, valueOrNull);

		if (typeof options.value === 'undefined' || options.value === null) {
			localStorage.removeItem(options.key);
		}
		else {
			localStorage.setItem(options.key, JSON.stringify(options.value));
		}
		return Promise.resolve();
	},

	removeItem(keyOrOptions) {
		const options = _prepOptions(keyOrOptions);

		localStorage.removeItem(options.key);
		return Promise.resolve();
	},

	hasItem(keyOrOptions) {
		const options = _prepOptions(keyOrOptions);
		const result = localStorage.getItem(options.key);

		Promise.resolve(result !== null);
	},

	clear() {
		localStorage.clear();
		return Promise.resolve();
	}

};

export default clientStorage;